export default __webpack_public_path__ + "static/media/icon_3.f2179c33.svg";